import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mail", "list"]

  connect() {
  }

  focus() {
    this.showList()
  }

  blur() {
    setTimeout(() => {
      this.hideList()
    }, 200)
  }

  selectDomain(event) {
    const domain = event.currentTarget.textContent.trim()
    const currentValue = this.mailTarget.value
    
    // @マークを含まない場合は、値全体を置き換える
    if (!currentValue.includes('@')) {
      this.mailTarget.value = currentValue + domain
    } else {
      // @マークが既に含まれている場合、@より前の部分を保持して、ドメイン部分を置き換える
      const username = currentValue.split('@')[0]
      this.mailTarget.value = username + domain
    }
    
    this.hideList()
  }

  showList() {
    this.listTarget.classList.add('is-active')
  }

  hideList() {
    this.listTarget.classList.remove('is-active')
  }
}
